<template>
  <div>
    <base-header class="pb-4">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Empleados</h6>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <vue-json-to-csv
            :json-data="itemsToExport"
            :csv-title="'empleados-' + new Date().valueOf()"
            :labels="labels"
            style="visibility: hidden"
          >
            <!--   <button>
              <b>My custom button</b>
            </button> -->
            <base-button size="sm" type="neutral" ref="myBtn"
              >Exportar</base-button
            >
          </vue-json-to-csv>
          <base-button
            size="sm"
            type="neutral"
            @click="enviar()"
            v-if="multipleSelection.length > 0"
          >
            Enviar mensaje
          </base-button>
          <base-button
            size="sm"
            type="neutral"
            @click="addUser()"
            :loading="loading"
            v-if="multipleSelection.length === 0"
            >Crear empleado</base-button
          >
          <base-button
            size="sm"
            type="neutral"
            @click="exportData()"
            :loading="loading"
            >Exportar</base-button
          >
        </div>
      </div>
      <!-- Card stats -->
      <!-- <div class="row pt-1">
        <div class="col-xl-4 col-md-6">
          <stats-card
            title="Activos"
            type="gradient-green"
            :sub-title="calcularTotalActivos(users).toString()"
            icon="ni ni-money-coins"
          >
            <template slot="footer">
              <span class="text-success mr-2">{{ calcularPorcentajeActivos(users) }}%</span>
              <span class="text-nowrap">de los empleados</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-4 col-md-6">
          <stats-card
            title="Inactivos"
            type="gradient-orange"
            :sub-title="calcularTotalInactivos(users).toString()"
            icon="ni ni-chart-pie-35"
          >
            <template slot="footer">
              <span class="text-success mr-2">{{ calcularPorcentajeInactivos(users) }}%</span>
              <span class="text-nowrap">de los empleados</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-4 col-md-6">
          <stats-card
            title="Pendientes"
            type="gradient-red"
            :sub-title="calcularTotalPendientes(users).toString()"
            icon="ni ni-active-40"
          >
            <template slot="footer">
              <span class="text-success mr-2">{{ calcularPorcentajePendientes(users) }}%</span>
              <span class="text-nowrap">de los empleados</span>
            </template>
          </stats-card>
        </div>
      </div> -->
    </base-header>

    <div class="container-fluid mt--4">
      <div class="row">
        <div class="col">
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <div class="p-2">
              <div
                class="row col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div class="col-md-4">
                  <div>
                    <form>
                      <base-input
                        v-model="query"
                        type="search"
                        prepend-icon="fas fa-search"
                        placeholder="Buscar por nombre, apellidos, email..."
                        clearable
                      />
                    </form>
                  </div>
                </div>
                <div class="col-md-8">
                  <div
                    class="d-flex justify-content-right justify-content-sm-end"
                  >
                    <div>
                      <el-select
                        class="select-primary pagination-select"
                        v-model="estado"
                        placeholder="Estado"
                        style="width: 100%; height: 46px !important"
                      >
                        <el-option
                          class="select-primary"
                          v-for="item in estados"
                          :key="item"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
              <!-- TABLA DE EMPLEADOS -->
              <el-table
                ref="multipleTable"
                class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="users"
                @sort-change="sortChange"
                @selection-change="handleSelectionChange"
                empty-text="No hay ningún elemento en esta tabla"
              >
                <!-- LOADING-->
                <div slot="empty" v-if="loading">
                  <img
                    src="/img/loading.gif"
                    style="height: 100px; width: 100px"
                  />
                </div>
                selection<el-table-column type="selection" width="30">
                </el-table-column>

                <el-table-column
                  label="Nombre y apellidos"
                  sortable="custom"
                  min-width="200px"
                >
                  <template v-slot="{ row }">
                    <img
                      v-if="row.imagen_perfil && row.imagen_perfil.url"
                      :src="row.imagen_perfil.url"
                      class="avatar rounded-circle mr-2"
                    />
                    <img
                      v-else
                      src="/img/placeholder.png"
                      class="avatar rounded-circle mr-2"
                    />

                    <b>{{ row.nombre + " " + row.apellidos }}</b>
                  </template>
                </el-table-column>

                <!--   <el-table-column
                  label="Nombre"
                  min-width="60px"
                  prop="nombre"
                  sortable="custom"
                />
                <el-table-column
                  label="Apellidos"
                  min-width="60px"
                  prop="apellidos"
                  sortable="custom"
                /> -->
                <!--  <el-table-column
                  label="Email"
                  min-width="140px"
                  prop="email"
                  sortable="custom"
                /> -->
                <!--  <el-table-column
                  label="Rol"
                  min-width="60px"
                  prop="role.name"
                  sortable="custom"
                >
                  <template v-slot="{ row }">
                    <span>{{ row.role.name }}</span>
                  </template>
                </el-table-column> -->
                <el-table-column
                  label="Estado"
                  min-width="70px"
                  prop="estado_usuario.id"
                  sortable="custom"
                >
                  <template slot-scope="{ row }">
                    <span
                      class="badge badge-default"
                      :style="[
                        row.estado_usuario.id == 1
                          ? { backgroundColor: 'orange' }
                          : row.estado_usuario.id == 2
                          ? { backgroundColor: 'green' }
                          : { backgroundColor: 'red' },
                      ]"
                      >{{ row.estado_usuario.estado }}</span
                    >
                  </template>
                </el-table-column>

                <el-table-column
                  label="Nº equipos"
                  min-width="100px"
                  sortable="custom"
                >
                  <template slot-scope="{ row }">
                    {{ row.activos.length }}
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="!isEmpresa172"
                  label="Aptos"
                  prop="completion"
                  min-width="120px"
                  sortable
                >
                  <template v-slot="{ row }">
                    <div class="d-flex align-items-center">
                      <span class="completion mr-2"
                        >{{ calcularPorcentajeAptos(row.activos) }}%</span
                      >
                      <div>
                        <base-progress
                          :value="calcularPorcentajeAptos(row.activos)"
                          :type="
                            getProgressType(
                              calcularPorcentajeAptos(row.activos)
                            )
                          "
                        />
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="Acciones" align="left">
                  <div slot-scope="{ row }" class="table-actions">
                    <base-button
                      outline
                      size="sm"
                      type="primary"
                      @click="editUser(row)"
                      style="padding-left: 10px; padding-right: 10px"
                      >Ver</base-button
                    >
                    <!--   <base-button
                      outline
                      size="sm"
                      type="danger"
                      @click="deleteUser(row.id)"
                      style="padding-left: 10px; padding-right: 10px"
                      >Eliminar</base-button
                    > -->
                    <!-- <el-tooltip content="Editar" placement="top">
                      <a
                        type="text"
                        @click="editUser(row)"
                        class="table-action"
                        data-toggle="tooltip"
                        style="cursor: pointer"
                      >
                        <i class="fas fa-user-edit fa-lg"></i>
                      </a>
                    </el-tooltip> -->

                    <!--  <el-tooltip content="Eliminar" placement="top">
                      <a
                        type="text"
                        @click="deleteUser(row.id)"
                        class="table-action table-action-delete"
                        data-toggle="tooltip"
                        style="cursor: pointer"
                      >
                        <i class="fas fa-trash fa-lg"></i>
                      </a>
                    </el-tooltip> -->
                  </div>
                </el-table-column>
              </el-table>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="row">
                <div class="col-xl-4">
                  <el-select
                    class="select-primary pagination-select"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div class="col-xl-8">
                  <p class="card-category" style="margin-top: 0.5rem">
                    Mostrando {{ total ? from + 1 : 0 }} - {{ to }} de
                    {{ total }} registros

                    <span v-if="selectedRows.length">
                      &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                    </span>
                  </p>
                </div>
              </div>

              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              />
            </div>
          </card>
        </div>
      </div>
    </div>
    <!-- DIALOG ENVIAR MENSAJE -->
    <el-dialog
      title="Enviar un mensaje"
      :visible.sync="dialogFormVisible"
      width="60%"
    >
      <div class="col-auto">
        <p>
          El mensaje se enviará por correo electrónico y notificación por App a
          los siguientes empleados:
        </p>
        <ul>
          <li
            v-for="empleado in this.multipleSelection"
            :key="empleado.id"
            :value="empleado.id"
          >
            <b>{{ empleado.nombre }} {{ empleado.apellidos }}</b>
          </li>
        </ul>
        <form @submit.prevent="handleSubmit">
          <base-input label="Mensaje">
            <textarea
              class="form-control"
              v-model="notificacion.descripcion"
              rows="4"
              placeholder=""
            ></textarea>
          </base-input>

          <span slot="footer" class="dialog-footer">
            <base-button
              @click="dialogFormVisible = false"
              type="secondary"
              style="margin-right: 8"
              >Cancelar</base-button
            >

            <base-button type="primary" native-type="submit" style="margin: 0">
              Enviar
            </base-button>
          </span>
        </form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { BasePagination } from "@/components";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
  Dialog,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work
moment.locale("es");

import VueJsonToCsv from "vue-json-to-csv";

export default {
  layout: "DashboardLayout",

  components: {
    BasePagination,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
  },

  data() {
    return {
      query: null,
      selectedRows: [],
      sort: "nombre",
      total: 0,
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [25, 50, 100],
      },
      dialogFormVisible: false,
      users: [],
      multipleSelection: [],
      loading: true,

      estado: null,
      estados: ["Todos", "Activo", "Inactivo", "Pendiente"],

      totalActivos: 0,
      totalInactivos: 0,
      totalPendientes: 0,
      totalEmpleados: 0,

      itemsToExport: [],

      labels: {
        username: { title: "Usuario" },
        nombre: { title: "Nombre" },
        apellidos: { title: "Apellidos" },
        email: { title: "Email" },
        telefono: { title: "Teléfono" },
        "estado_usuario.estado": { title: "Estado" },
      },
      searchParams: {
        nombre: "",
        apellidos: "",
        email: "",
      },
      notificacion: {
        type: "notificaciones",
        descripcion: null,
        estado_notificacion: {
          id: 1,
        },
        tipo_notificacion: {
          id: 5,
        },
        usuario_origen: {
          id: null,
        },
        usuario_destinos: [],
        empresa: {
          id: null,
        },
      },
    };
  },
  computed: {
    isEmpresa172() {
      const planta = localStorage.getItem("plantaSelected");
      return Number(planta) === 172 || planta === "172";
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },
  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    estado: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    enviar() {
      this.dialogFormVisible = true;
    },

    async handleSubmit() {
      this.notificacion.usuario_destinos = this.multipleSelection;
      console.log("NOTIFICACIÓN: ");
      console.log(this.notificacion);

      try {
        await this.$store.dispatch("notificaciones/add", this.notificacion);
        this.$notify({
          type: "success",
          message: "Se ha enviado la notificación correctamente.",
        });
        this.dialogFormVisible = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, algo ha ido mal",
        });
        this.setApiValidation(error.response.data.error.details.errors);
      }
    },

    async getList() {
      this.loading = true;
      var planta = localStorage.getItem("plantaSelected");

      try {
        await this.$store.dispatch("profile/me");
        let profile = await this.$store.getters["profile/me"];
        this.notificacion.usuario_origen.id = profile.id;
        this.notificacion.empresa.id = planta;

        await this.$store
          .dispatch("users/fetchEmpleados", {
            idEmpresa: planta,
            search: this.query,
            estado: this.estado,
            populate: ["activos", "activos.revisiones"],
          })
          .then(() => {
            this.users = this.$store.getters["users/empleados"];
            console.log('Respuesta de users/fetchEmpleados:', this.users);
          });
      } catch (error) {
        console.error("Error fetching employees:", error);
      } finally {
        this.loading = false;
      }
    },

    async exportData() {
      this.loading = true;
      var planta = localStorage.getItem("plantaSelected");

      await this.$store
        .dispatch("users/fetchEmpleados", {
          idEmpresa: planta,
          search: this.query,
          estado: this.estado,
        })
        .then(() => {
          var items = this.$store.getters["users/empleados"];

          console.log(items.length);

          var itemsFlatten = [];
          items.forEach((item) => {
            itemsFlatten.push(this.flattenObject(item));
          });

          console.log(itemsFlatten);

          this.itemsToExport = itemsFlatten;

          /* const elem = this.$refs.myBtn;
          elem.click(); */
          setTimeout(() => {
            this.$refs.myBtn.$el.click();
            this.loading = false;
          }, 500);
          this.loading = false;
        });
    },
    flattenObject(obj) {
      let flattenKeys = {};
      for (let i in obj) {
        if (!obj.hasOwnProperty(i)) continue;
        if (typeof obj[i] == "object") {
          // flattenKeys[i] = obj[i];
          let flatObject = this.flattenObject(obj[i]);
          for (let j in flatObject) {
            if (!flatObject.hasOwnProperty(j)) continue;
            flattenKeys[i + "." + j] = flatObject[j];
          }
        } else {
          flattenKeys[i] = obj[i];
        }
      }
      return flattenKeys;
    },
    async deleteUser(id) {
      if (this.$isDemo && ["1", "2", "3"].includes(id)) {
        this.$notify({
          type: "danger",
          message: "You are not allowed not change data of default users.",
        });
        return;
      }
      const confirmation = await swal.fire({
        title: `Eliminar este usuario. ¿Estás seguro?`,
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sí. Eliminar",
        cancelButtonText: "No. Cancelar",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch("users/destroy", id);
          await this.getList();
          this.$notify({
            type: "success",
            message: "Usuario eliminado correctamente.",
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, ha habido un error",
        });
      }
    },
    addUser() {
      this.$router.push({ name: "Add User" });
    },
    async editUser(row) {
      /*  await this.$store.dispatch("profile/me");
      let me = await this.$store.getters["profile/me"];

      if (row.id === me.id) {
        this.$router.push({ name: "User Profile" });
      } else { */
      this.$router.push({
        name: "Edit User",
        params: { id: row.id },
      });
      /*  } */
    },
    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
    calcularPorcentajeAptos(activos) {
      console.log("-------- CALCULANDO PORCENTAJE APTOS --------");
      if (!activos || activos.length === 0) {
        console.log("No hay activos, retornando 0%");
        return 0;
      }

      // Filtrar primero los equipos no retirados
      const equiposActivos = activos.filter((activo) => !activo.retirado);
      console.log(`Total activos originales: ${activos.length}`);
      console.log(`Total activos no retirados: ${equiposActivos.length}`);

      const totalEquipos = equiposActivos.length;
      if (totalEquipos === 0) {
        console.log("No hay equipos activos (todos retirados), retornando 0%");
        return 0;
      }

      let equiposAptos = 0;

      equiposActivos.forEach((activo) => {
        console.log("Revisando activo:", activo);
        
        // Un equipo es apto si:
        // 1. Tiene fecha de próxima revisión
        // 2. La fecha de próxima revisión no ha pasado
        // 3. Su estado es "apto" (si existe el campo)
        
        if (!activo.fecha_prox_revision) {
          console.log("❌ El equipo NO es apto (sin fecha de próxima revisión)");
          return;
        }

        const fechaProxRevision = moment(activo.fecha_prox_revision);
        const ahora = moment();
        const estaCaducado = fechaProxRevision.isBefore(ahora);
        
        console.log(`Fecha próxima revisión: ${fechaProxRevision.format("DD/MM/YYYY")}`);
        console.log(`¿Está caducado?: ${estaCaducado}`);

        // Si el activo tiene un campo estado, verificarlo
        if (activo.estado && activo.estado !== "apto") {
          console.log(`❌ El equipo NO es apto (estado: ${activo.estado})`);
          return;
        }

        if (!estaCaducado) {
          equiposAptos++;
          console.log("✅ El equipo es APTO (no caducado)");
        } else {
          console.log("❌ El equipo NO es apto (caducado)");
        }
      });

      const porcentaje = Math.round((equiposAptos * 100) / totalEquipos);
      console.log(`\nResumen final:`);
      console.log(`- Total equipos activos: ${totalEquipos}`);
      console.log(`- Equipos aptos: ${equiposAptos}`);
      console.log(`- Porcentaje: ${porcentaje}%`);
      console.log("----------------------------------------\n");

      return porcentaje;
    },

    getProgressType(porcentaje) {
      if (porcentaje >= 90) return "success";
      if (porcentaje >= 50) return "warning";
      return "danger";
    },
  },
};
</script>
